import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SplashBackground from '../components/SplashBackground';

const Splash = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/auth'),2500);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Dimmed background */}
      <div className="absolute inset-0 bg-black/5 z-[5]"></div>
      <SplashBackground />
      

      <div className="absolute z-[8]">
        <div className="relative">
          {/* Large outer glow */}
          <div className="absolute inset-0 w-[500px] h-[500px] -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 bg-gradient-radial from-[#FDB913]/15 via-[#FDE9EB]/10 to-transparent rounded-full blur-3xl animate-pulse"></div>
          
          {/* Medium glow */}
          <div className="absolute inset-0 w-[350px] h-[350px] -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 bg-gradient-radial from-[#FFA500]/12 via-[#FDB913]/8 to-transparent rounded-full blur-2xl"></div>
          
          {/* Inner bright glow */}
          <div className="absolute inset-0 w-[200px] h-[200px] -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 bg-gradient-radial from-white/20 via-[#FDB913]/15 to-transparent rounded-full blur-xl animate-pulse"></div>
        </div>
      </div>

      {/* Logo with enhanced effects */}
      <div className="relative z-10">
        {/* Spotlight effect */}
        <div className="absolute inset-0 -inset-12 bg-gradient-radial from-white/30 to-transparent rounded-full blur-2xl"></div>
        
        <img
          src="/TiflLogo.png"
          alt="Tifl"
          className="relative select-none w-80 sm:w-122 md:w-144 lg:w-120 xl:w-[32rem] 2xl:w-[36rem] h-auto drop-shadow-2xl animate-float"
          draggable="false"
          style={{
            filter: 'drop-shadow(0 20px 40px rgba(253, 185, 19, 0.3)) drop-shadow(0 0 80px rgba(253, 185, 19, 0.2))'
          }}
        />
      </div>

      <style jsx="true">{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-15px) scale(1.02);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .bg-gradient-radial {
          background: radial-gradient(circle, var(--tw-gradient-stops));
        }
      `}</style>
    </div>
  );
};

export default Splash;